import {
  classTypes,
  fieldNames,
  IPLAN_PROPERTY_LABELS,
  ISHELL_PROPERTY_LABELS,
  IUNIT_PROPERTY_LABELS,
  shellFieldNames,
  unitFieldNames,
} from 'src/lib/constants'

export interface FilterMenuItems {
  appliedTo: classTypes[]
  displayName: string
  enabled: boolean
  id: string
}

export interface ComparisonAttributeItem {
  appliedTo: classTypes[]
  displayName: string
  enabled: boolean
  id: string
  isRequired: boolean
}

// TODO: Clean up filters after multi family filtered api refactor

export const filterMenuFields: FilterMenuItems[] = [
  {
    appliedTo: [classTypes.SHELL, classTypes.SINGLE, classTypes.UNIT],
    displayName: 'Plan Name',
    enabled: false,
    id: 'planName',
  },
  {
    appliedTo: [classTypes.SINGLE],
    displayName: 'Plan Status',
    enabled: false,
    id: 'planStatus',
  },
  {
    appliedTo: [classTypes.UNIT],
    displayName: 'Unit Status',
    enabled: false,
    id: 'unitStatus',
  },
  {
    appliedTo: [classTypes.SHELL],
    displayName: 'Shell Status',
    enabled: false,
    id: 'shellStatus',
  },
  {
    appliedTo: [classTypes.SINGLE],
    displayName: 'Plan Type',
    enabled: false,
    id: 'planType',
  },
  {
    appliedTo: [classTypes.UNIT],
    displayName: 'Unit Type',
    enabled: false,
    id: 'unitType',
  },
  {
    appliedTo: [classTypes.SHELL],
    displayName: 'Shell Type',
    enabled: false,
    id: 'shellType',
  },
  {
    appliedTo: [classTypes.SHELL, classTypes.SINGLE, classTypes.UNIT],
    displayName: 'Division',
    enabled: true,
    id: 'division',
  },
  {
    appliedTo: [classTypes.SINGLE, classTypes.UNIT],
    displayName: 'Value Engineered',
    enabled: false,
    id: 'valueEngineered',
  },
  {
    appliedTo: [classTypes.SHELL, classTypes.SINGLE, classTypes.UNIT],
    displayName: 'Base Plan',
    enabled: false,
    id: 'basePlan',
  },
  {
    appliedTo: [classTypes.UNIT],
    displayName: 'Unit Elevation',
    enabled: false,
    id: 'unitElevation',
  },
  {
    appliedTo: [classTypes.SHELL],
    displayName: 'Shell Elevation',
    enabled: false,
    id: 'shellElevation',
  },
  {
    appliedTo: [classTypes.SHELL],
    displayName: 'Units',
    enabled: false,
    id: 'units',
  },
  {
    appliedTo: [classTypes.SINGLE],
    displayName: 'Plan Owned By Lennar',
    enabled: false,
    id: 'planOwnedByLennar',
  },
  {
    appliedTo: [classTypes.UNIT],
    displayName: 'Unit Owned By Lennar',
    enabled: false,
    id: 'unitOwnedByLennar',
  },
  {
    appliedTo: [classTypes.SINGLE, classTypes.UNIT],
    displayName: 'Formal Living Room',
    enabled: false,
    id: 'formalLivingRoom',
  },
  {
    appliedTo: [classTypes.SHELL, classTypes.SINGLE, classTypes.UNIT],
    displayName: 'Foundation Type',
    enabled: false,
    id: 'foundationType',
  },
  {
    appliedTo: [classTypes.SHELL, classTypes.UNIT],
    displayName: 'Created On',
    enabled: false,
    id: 'createdOn',
  },
  {
    appliedTo: [classTypes.SINGLE],
    displayName: 'Created On',
    enabled: false,
    id: 'planCreatedDateTime',
  },
  {
    appliedTo: [classTypes.SHELL, classTypes.UNIT],
    displayName: 'Modified On',
    enabled: false,
    id: 'modifiedOn',
  },
  {
    appliedTo: [classTypes.SINGLE],
    displayName: 'Modified On',
    enabled: false,
    id: 'planModifiedDateTime',
  },
  {
    appliedTo: [classTypes.SHELL, classTypes.SINGLE, classTypes.UNIT],
    displayName: 'Stories',
    enabled: false,
    id: 'stories',
  },
  {
    appliedTo: [classTypes.SINGLE, classTypes.UNIT],
    displayName: 'Bedrooms',
    enabled: false,
    id: 'bedrooms',
  },
  {
    appliedTo: [classTypes.SINGLE, classTypes.UNIT],
    displayName: 'Half Bathrooms',
    enabled: false,
    id: 'halfBathrooms',
  },
  {
    appliedTo: [classTypes.SHELL, classTypes.SINGLE, classTypes.UNIT],
    displayName: 'Plan Category',
    enabled: true,
    id: 'planCategory',
  },
  {
    appliedTo: [classTypes.SHELL, classTypes.SINGLE, classTypes.UNIT],
    displayName: 'Derived From Core',
    enabled: false,
    id: 'derivedFromCore',
  },
  {
    appliedTo: [classTypes.SHELL, classTypes.SINGLE, classTypes.UNIT],
    displayName: 'Hierarchy',
    enabled: false,
    id: 'hierarchy',
  },
  {
    appliedTo: [classTypes.SHELL, classTypes.SINGLE, classTypes.UNIT],
    displayName: 'Community Name',
    enabled: false,
    id: 'communityName',
  },
  {
    appliedTo: [classTypes.SHELL, classTypes.SINGLE, classTypes.UNIT],
    displayName: 'Community Number',
    enabled: false,
    id: 'communityId',
  },
  {
    appliedTo: [classTypes.SHELL, classTypes.SINGLE, classTypes.UNIT],
    displayName: 'Marketing Name',
    enabled: false,
    id: 'marketingName',
  },
  {
    appliedTo: [classTypes.SHELL, classTypes.UNIT],
    displayName: 'Created By',
    enabled: false,
    id: 'createdBy',
  },
  {
    appliedTo: [classTypes.SINGLE],
    displayName: 'Created By',
    enabled: false,
    id: 'planCreatedBy',
  },
  {
    appliedTo: [classTypes.SHELL, classTypes.SINGLE, classTypes.UNIT],
    displayName: 'Region',
    enabled: true,
    id: 'region',
  },
  {
    appliedTo: [classTypes.UNIT],
    displayName: 'Conditioned Space Sq Ft',
    enabled: false,
    id: 'conditionedSpaceSqFt',
  },
  {
    appliedTo: [classTypes.SINGLE],
    displayName: 'Conditioned Space Sq Ft',
    enabled: false,
    id: 'sqftOfHomeConditionedSpace',
  },
  {
    appliedTo: [classTypes.SINGLE],
    displayName: 'Width Of Plan Ft',
    enabled: false,
    id: 'widthOfPlan',
  },
  {
    appliedTo: [classTypes.SINGLE],
    displayName: 'Depth Of Plan Ft',
    enabled: false,
    id: 'depthOfPlan',
  },
  {
    appliedTo: [classTypes.UNIT],
    displayName: 'Width Of Unit Ft',
    enabled: false,
    id: 'widthOfUnitInFeet',
  },
  {
    appliedTo: [classTypes.UNIT],
    displayName: 'Depth Of Unit Ft',
    enabled: false,
    id: 'depthOfUnitInFeet',
  },
  {
    appliedTo: [classTypes.SHELL],
    displayName: 'Width Of Building Ft',
    enabled: false,
    id: 'buildingWidthFt',
  },
  {
    appliedTo: [classTypes.SHELL],
    displayName: 'Depth Of Building Ft',
    enabled: false,
    id: 'buildingDepthFt',
  },
  {
    appliedTo: [classTypes.SINGLE],
    displayName: 'Garage Alignment',
    enabled: false,
    id: 'garageAlignment',
  },
  {
    appliedTo: [classTypes.SINGLE, classTypes.UNIT],
    displayName: 'Indoor Fireplace',
    enabled: false,
    id: 'indoorFireplace',
  },
  {
    appliedTo: [classTypes.SINGLE, classTypes.UNIT],
    displayName: 'Formal Dining Room',
    enabled: false,
    id: 'formalDiningRoom',
  },
  {
    appliedTo: [classTypes.SINGLE, classTypes.UNIT],
    displayName: 'Full Bathrooms',
    enabled: false,
    id: 'fullBathrooms',
  },
  {
    appliedTo: [classTypes.SINGLE, classTypes.UNIT],
    displayName: 'Basement',
    enabled: false,
    id: 'basement',
  },
  {
    appliedTo: [classTypes.SINGLE],
    displayName: 'Total Home Sq Ft',
    enabled: false,
    id: 'homeSqft',
  },
  {
    appliedTo: [classTypes.UNIT],
    displayName: 'Total Unit Sq Ft',
    enabled: false,
    id: 'totalUnitSqFt',
  },
  {
    appliedTo: [classTypes.SHELL, classTypes.SINGLE, classTypes.UNIT],
    displayName: 'Garage Att/Det',
    enabled: false,
    id: 'garageType',
  },
  {
    appliedTo: [classTypes.SINGLE],
    displayName: 'Garage Load',
    enabled: false,
    id: 'garageLoad',
  },
  {
    appliedTo: [classTypes.SINGLE, classTypes.SHELL, classTypes.UNIT],
    displayName: 'No. Of Cars/Garages',
    enabled: false,
    id: 'numberOfCarGarages',
  },
  {
    appliedTo: [classTypes.SINGLE, classTypes.UNIT],
    displayName: 'Great Room',
    enabled: false,
    id: 'greatRoom',
  },
  {
    appliedTo: [classTypes.SINGLE, classTypes.UNIT],
    displayName: 'Outdoor Fireplace',
    enabled: false,
    id: 'outdoorFireplace',
  },
  {
    appliedTo: [classTypes.SHELL, classTypes.SINGLE],
    displayName: 'Exterior Cladding',
    enabled: false,
    id: 'exteriorCladding',
  },
  {
    appliedTo: [classTypes.SHELL, classTypes.SINGLE, classTypes.UNIT],
    displayName: 'Exterior Wall Construction',
    enabled: false,
    id: 'exteriorWallConstruction',
  },
  {
    appliedTo: [classTypes.UNIT, classTypes.SINGLE],
    displayName: 'Entry',
    enabled: false,
    id: 'entry',
  },
  {
    appliedTo: [classTypes.SINGLE, classTypes.UNIT],
    displayName: 'Loft',
    enabled: false,
    id: 'loft',
  },
  {
    appliedTo: [classTypes.SINGLE, classTypes.UNIT],
    displayName: 'Game Room',
    enabled: false,
    id: 'gameRoom',
  },
  {
    appliedTo: [classTypes.SINGLE, classTypes.UNIT],
    displayName: 'Study',
    enabled: false,
    id: 'study',
  },
  {
    appliedTo: [classTypes.SINGLE, classTypes.UNIT],
    displayName: 'Flex',
    enabled: false,
    id: 'flex',
  },
  {
    appliedTo: [classTypes.SINGLE, classTypes.UNIT],
    displayName: 'Family Room',
    enabled: false,
    id: 'familyRoom',
  },
  {
    appliedTo: [classTypes.SINGLE, classTypes.UNIT],
    displayName: 'Bonus Room',
    enabled: false,
    id: 'bonusRoom',
  },
  {
    appliedTo: [classTypes.SINGLE, classTypes.UNIT],
    displayName: 'Sun Room',
    enabled: false,
    id: 'sunRoom',
  },
  {
    appliedTo: [classTypes.SINGLE, classTypes.UNIT],
    displayName: 'Series',
    enabled: false,
    id: 'series',
  },
  {
    appliedTo: [classTypes.SINGLE, classTypes.SHELL, classTypes.UNIT],
    displayName: 'No. Of Cars/Garages 2',
    enabled: false,
    id: 'numberOfCarGarages2',
  },
  {
    appliedTo: [classTypes.SINGLE, classTypes.SHELL, classTypes.UNIT],
    displayName: 'Garage Size',
    enabled: false,
    id: 'garageSize',
  },
  {
    appliedTo: [classTypes.SINGLE, classTypes.SHELL, classTypes.UNIT],
    displayName: 'Garage Size 2',
    enabled: false,
    id: 'garageSize2',
  },
  {
    appliedTo: [classTypes.SINGLE, classTypes.SHELL, classTypes.UNIT],
    displayName: 'Year of Creation',
    enabled: false,
    id: 'yearOfCreation',
  },
  {
    appliedTo: [classTypes.SINGLE, classTypes.UNIT],
    displayName: 'Architecture Firm Name',
    enabled: false,
    id: 'firmName',
  },
  {
    appliedTo: [classTypes.SINGLE, classTypes.UNIT],
    displayName: 'Engineer Name',
    enabled: false,
    id: 'engineerName',
  },
  {
    appliedTo: [classTypes.SINGLE, classTypes.UNIT],
    displayName: 'Plan Change Number',
    enabled: false,
    id: 'changeNumber',
  },
  {
    appliedTo: [classTypes.UNIT],
    displayName: 'Base Unit Price',
    enabled: false,
    id: 'baseUnitPrice',
  },
  {
    appliedTo: [classTypes.UNIT],
    displayName: 'Base Unit Pre',
    enabled: false,
    id: 'baseUnitPre',
  },
  {
    appliedTo: [classTypes.SINGLE],
    displayName: 'Base House Price',
    enabled: false,
    id: 'baseHomePrice',
  },
  {
    appliedTo: [classTypes.SINGLE],
    displayName: 'Base House Pre',
    enabled: false,
    id: 'baseHousePre',
  },
  {
    appliedTo: [classTypes.SINGLE, classTypes.UNIT],
    displayName: 'Effective Date',
    enabled: false,
    id: 'effectiveDate',
  },
  {
    appliedTo: [classTypes.SINGLE],
    displayName: 'Target Profit Percentage',
    enabled: false,
    id: 'targetProfitPercentage',
  },
  {
    appliedTo: [classTypes.SINGLE, classTypes.UNIT],
    displayName: 'Number of Living Areas',
    enabled: false,
    id: 'livingAreas',
  },
  {
    appliedTo: [classTypes.SINGLE, classTypes.UNIT],
    displayName: 'Owners Suite Location',
    enabled: false,
    id: 'masterBedroomLocation',
  },
  {
    appliedTo: [classTypes.SINGLE],
    displayName: 'Under Roof Sq Ft',
    enabled: false,
    id: 'sqftOfHomeUnderRoof',
  },
  {
    appliedTo: [classTypes.UNIT],
    displayName: 'Under Roof Sq Ft',
    enabled: false,
    id: 'sqftOfUnitUnderRoof',
  },
  {
    appliedTo: [classTypes.SHELL],
    displayName: 'Building Total Under Roof Sq Ft',
    enabled: false,
    id: 'underRoofSqFt',
  },
  {
    appliedTo: [classTypes.SHELL],
    displayName: 'Building Living Sq Ft',
    enabled: false,
    id: 'buildingSqFt',
  },
  {
    appliedTo: [classTypes.SINGLE],
    displayName: 'Roof Shape',
    enabled: false,
    id: 'roofShape',
  },
  {
    appliedTo: [classTypes.SINGLE],
    displayName: 'Material Roof Type',
    enabled: false,
    id: 'materialRoofType',
  },
  {
    appliedTo: [classTypes.SINGLE, classTypes.UNIT, classTypes.SHELL],
    displayName: 'Interior Wall Construction',
    enabled: false,
    id: 'interiorWallConstruction',
  },
  {
    appliedTo: [classTypes.SINGLE, classTypes.UNIT],
    displayName: 'Entry Size Sq Ft',
    enabled: false,
    id: 'entrySqft',
  },
  {
    appliedTo: [classTypes.SINGLE],
    displayName: 'Optional Garage',
    enabled: false,
    id: 'optionalGarage',
  },
  {
    appliedTo: [classTypes.SINGLE],
    displayName: 'Golf Cart Garage',
    enabled: false,
    id: 'golfCartGarage',
  },
  {
    appliedTo: [classTypes.SINGLE],
    displayName: 'RV Garage',
    enabled: false,
    id: 'rvGarage',
  },
  {
    appliedTo: [classTypes.SINGLE, classTypes.UNIT],
    displayName: 'Number of Dining Areas',
    enabled: false,
    id: 'numberOfDiningAreas',
  },
  {
    appliedTo: [classTypes.SINGLE, classTypes.UNIT],
    displayName: 'Interior Sprinklers',
    enabled: false,
    id: 'interiorSprinklers',
  },
  {
    appliedTo: [classTypes.SINGLE, classTypes.UNIT],
    displayName: 'Storm Shutters',
    enabled: false,
    id: 'stormShutters',
  },
  {
    appliedTo: [classTypes.SINGLE, classTypes.UNIT],
    displayName: 'Patio',
    enabled: false,
    id: 'patio',
  },
  {
    appliedTo: [classTypes.SINGLE, classTypes.UNIT],
    displayName: 'Impact Windows',
    enabled: false,
    id: 'impactWindows',
  },
  {
    appliedTo: [classTypes.SINGLE, classTypes.UNIT],
    displayName: 'Outdoor Kitchen',
    enabled: false,
    id: 'outdoorKitchen',
  },
  {
    appliedTo: [classTypes.SINGLE, classTypes.UNIT],
    displayName: 'Vaulted Ceiling',
    enabled: false,
    id: 'vaultedCeiling',
  },
  {
    appliedTo: [classTypes.SINGLE, classTypes.UNIT],
    displayName: 'Lanai/Enclosures',
    enabled: false,
    id: 'lanaiEnclosures',
  },
  {
    appliedTo: [classTypes.SINGLE, classTypes.UNIT],
    displayName: 'Deck',
    enabled: false,
    id: 'deck',
  },
]

export const exportMenuFields: FilterMenuItems[] = [
  ...filterMenuFields.map((field) => ({
    ...field,
    enabled: true,
  })),
  {
    appliedTo: [classTypes.SINGLE],
    displayName: 'Plan Elevation',
    enabled: true,
    id: 'planElevation',
  },
  {
    appliedTo: [classTypes.SINGLE, classTypes.UNIT, classTypes.SHELL],
    displayName: IPLAN_PROPERTY_LABELS.exportFloorPlans,
    enabled: true,
    id: fieldNames.EXPORT_FLOOR_PLANS,
  },
]

export const comparisonAttributeFields: ComparisonAttributeItem[] = [
  {
    appliedTo: [classTypes.SINGLE],
    displayName: IPLAN_PROPERTY_LABELS.additionalBathrooms,
    enabled: true,
    id: fieldNames.ADDITIONAL_BATHROOMS,
    isRequired: false,
  },
  {
    appliedTo: [classTypes.SINGLE],
    displayName: IPLAN_PROPERTY_LABELS.baseHousePrice,
    enabled: true,
    id: fieldNames.BASE_HOUSE_PRICE,
    isRequired: false,
  },
  {
    appliedTo: [classTypes.SINGLE],
    displayName: IPLAN_PROPERTY_LABELS.baseHousePre,
    enabled: true,
    id: fieldNames.BASE_HOUSE_PRE,
    isRequired: false,
  },
  {
    appliedTo: [classTypes.SINGLE, classTypes.UNIT],
    displayName: IPLAN_PROPERTY_LABELS.basement,
    enabled: true,
    id: fieldNames.BASEMENT,
    isRequired: false,
  },
  {
    appliedTo: [classTypes.UNIT],
    displayName: IUNIT_PROPERTY_LABELS.baseUnitPre,
    enabled: true,
    id: unitFieldNames.BASE_UNIT_PRE,
    isRequired: false,
  },
  {
    appliedTo: [classTypes.UNIT],
    displayName: IUNIT_PROPERTY_LABELS.baseUnitPrice,
    enabled: true,
    id: unitFieldNames.BASE_UNIT_PRICE,
    isRequired: false,
  },
  {
    appliedTo: [classTypes.SINGLE, classTypes.UNIT],
    displayName: IPLAN_PROPERTY_LABELS.bedrooms,
    enabled: true,
    id: fieldNames.BEDROOMS,
    isRequired: false,
  },
  {
    appliedTo: [classTypes.SINGLE, classTypes.UNIT],
    displayName: IPLAN_PROPERTY_LABELS.bonusRoom,
    enabled: true,
    id: fieldNames.BONUS_ROOM,
    isRequired: false,
  },
  {
    appliedTo: [classTypes.SHELL],
    displayName: ISHELL_PROPERTY_LABELS.buildingDepthFeet,
    enabled: true,
    id: shellFieldNames.DEPTH_BUILDING_FT,
    isRequired: false,
  },
  {
    appliedTo: [classTypes.SHELL],
    displayName: ISHELL_PROPERTY_LABELS.buildingDepthInch,
    enabled: true,
    id: shellFieldNames.DEPTH_BUILDING_IN,
    isRequired: false,
  },
  {
    appliedTo: [classTypes.SHELL],
    displayName: ISHELL_PROPERTY_LABELS.buildingSqFt,
    enabled: true,
    id: shellFieldNames.BUILDING_SQ_FT,
    isRequired: false,
  },
  {
    appliedTo: [classTypes.SHELL],
    displayName: ISHELL_PROPERTY_LABELS.buildingWidthFeet,
    enabled: true,
    id: shellFieldNames.WIDTH_BUILDING_FT,
    isRequired: false,
  },
  {
    appliedTo: [classTypes.SHELL],
    displayName: ISHELL_PROPERTY_LABELS.buildingWidthInch,
    enabled: true,
    id: shellFieldNames.WIDTH_BUILDING_IN,
    isRequired: false,
  },
  {
    appliedTo: [classTypes.SINGLE],
    displayName: IPLAN_PROPERTY_LABELS.depthOfThePlanInFeet,
    enabled: true,
    id: fieldNames.DEPTH_FT,
    isRequired: false,
  },
  {
    appliedTo: [classTypes.SINGLE],
    displayName: IPLAN_PROPERTY_LABELS.depthOfThePlanInInch,
    enabled: true,
    id: fieldNames.DEPTH_IN,
    isRequired: false,
  },
  {
    appliedTo: [classTypes.SHELL],
    displayName: ISHELL_PROPERTY_LABELS.derivedFromCore,
    enabled: true,
    id: shellFieldNames.DERIVED_FROM_CORE,
    isRequired: false,
  },
  {
    appliedTo: [classTypes.SINGLE, classTypes.UNIT, classTypes.SHELL],
    displayName: IPLAN_PROPERTY_LABELS.division,
    enabled: true,
    id: fieldNames.DIVISION,
    isRequired: true,
  },
  {
    appliedTo: [classTypes.SINGLE, classTypes.SHELL],
    displayName: IPLAN_PROPERTY_LABELS.exteriorCladding,
    enabled: true,
    id: fieldNames.EXTERIOR_CLADDING,
    isRequired: false,
  },
  {
    appliedTo: [classTypes.SINGLE, classTypes.SHELL],
    displayName: IPLAN_PROPERTY_LABELS.exteriorWallConstruction,
    enabled: true,
    id: fieldNames.EXTERIOR_WALL_CONSTRUCTION,
    isRequired: false,
  },
  {
    appliedTo: [classTypes.SINGLE],
    displayName: IPLAN_PROPERTY_LABELS.familyRoom,
    enabled: true,
    id: fieldNames.FAMILY_ROOM,
    isRequired: false,
  },
  {
    appliedTo: [classTypes.SINGLE],
    displayName: IPLAN_PROPERTY_LABELS.flex,
    enabled: true,
    id: fieldNames.FLEX,
    isRequired: false,
  },
  {
    appliedTo: [classTypes.SINGLE],
    displayName: IPLAN_PROPERTY_LABELS.formalLivingRoom,
    enabled: true,
    id: fieldNames.FORMAL_LIVING_ROOM,
    isRequired: false,
  },
  {
    appliedTo: [classTypes.SINGLE, classTypes.UNIT, classTypes.SHELL],
    displayName: IPLAN_PROPERTY_LABELS.foundationType,
    enabled: true,
    id: fieldNames.FOUNDATION_TYPE,
    isRequired: false,
  },
  {
    appliedTo: [classTypes.SINGLE],
    displayName: IPLAN_PROPERTY_LABELS.fullBathrooms,
    enabled: true,
    id: fieldNames.FULL_BATHROOMS,
    isRequired: false,
  },
  {
    appliedTo: [classTypes.SINGLE],
    displayName: IPLAN_PROPERTY_LABELS.gameRoom,
    enabled: true,
    id: fieldNames.GAME_ROOM,
    isRequired: false,
  },
  {
    appliedTo: [classTypes.SINGLE],
    displayName: IPLAN_PROPERTY_LABELS.garageAlignment,
    enabled: true,
    id: fieldNames.GARAGE_ALIGNMENT,
    isRequired: false,
  },
  {
    appliedTo: [classTypes.SINGLE, classTypes.SHELL, classTypes.UNIT],
    displayName: ISHELL_PROPERTY_LABELS.garageLoad,
    enabled: true,
    id: fieldNames.GARAGE_LOAD,
    isRequired: false,
  },
  {
    appliedTo: [classTypes.SINGLE, classTypes.SHELL, classTypes.UNIT],
    displayName: IPLAN_PROPERTY_LABELS.garageSize,
    enabled: true,
    id: fieldNames.GARAGE_SIZE_SQ_FT,
    isRequired: false,
  },
  {
    appliedTo: [classTypes.SINGLE, classTypes.SHELL, classTypes.UNIT],
    displayName: IPLAN_PROPERTY_LABELS.garageSize2,
    enabled: true,
    id: fieldNames.GARAGE_SIZE_2,
    isRequired: false,
  },
  {
    appliedTo: [classTypes.SINGLE, classTypes.SHELL, classTypes.UNIT],
    displayName: IPLAN_PROPERTY_LABELS.garageType,
    enabled: true,
    id: fieldNames.GARAGE_ATT_DET,
    isRequired: false,
  },
  {
    appliedTo: [classTypes.SINGLE],
    displayName: IPLAN_PROPERTY_LABELS.greatRoom,
    enabled: true,
    id: fieldNames.GREAT_ROOM,
    isRequired: false,
  },
  {
    appliedTo: [classTypes.SINGLE],
    displayName: IPLAN_PROPERTY_LABELS.halfBathrooms,
    enabled: true,
    id: fieldNames.HALF_BATHROOMS,
    isRequired: false,
  },
  {
    appliedTo: [classTypes.SHELL],
    displayName: ISHELL_PROPERTY_LABELS.hierarchy,
    enabled: true,
    id: fieldNames.HIERARCHY,
    isRequired: false,
  },
  {
    appliedTo: [classTypes.SINGLE],
    displayName: IPLAN_PROPERTY_LABELS.homeSqft,
    enabled: true,
    id: fieldNames.SQFT_HOME,
    isRequired: false,
  },
  {
    appliedTo: [classTypes.SINGLE, classTypes.UNIT],
    displayName: IPLAN_PROPERTY_LABELS.livingAreas,
    enabled: true,
    id: fieldNames.LIVING_AREAS,
    isRequired: false,
  },
  {
    appliedTo: [classTypes.SINGLE, classTypes.UNIT],
    displayName: IPLAN_PROPERTY_LABELS.loft,
    enabled: true,
    id: fieldNames.LOFT,
    isRequired: false,
  },
  {
    appliedTo: [classTypes.SINGLE, classTypes.UNIT, classTypes.SHELL],
    displayName: IPLAN_PROPERTY_LABELS.marketingName,
    enabled: true,
    id: fieldNames.MARKETING_NAME,
    isRequired: false,
  },
  {
    appliedTo: [classTypes.SINGLE, classTypes.SHELL, classTypes.UNIT],
    displayName: IPLAN_PROPERTY_LABELS.numberOfCarGarages,
    enabled: true,
    id: fieldNames.NUMBER_OF_CARS_GARAGES,
    isRequired: false,
  },
  {
    appliedTo: [classTypes.SINGLE, classTypes.SHELL, classTypes.UNIT],
    displayName: IPLAN_PROPERTY_LABELS.numberOfCarGarages2,
    enabled: true,
    id: fieldNames.NUMBER_OF_CARS_GARAGES_2,
    isRequired: false,
  },
  {
    appliedTo: [classTypes.SINGLE, classTypes.UNIT, classTypes.SHELL],
    displayName: IPLAN_PROPERTY_LABELS.parentPlanName,
    enabled: true,
    id: fieldNames.PARENT_PLAN_NAME,
    isRequired: false,
  },
  {
    appliedTo: [classTypes.SINGLE],
    displayName: IPLAN_PROPERTY_LABELS.patio,
    enabled: true,
    id: fieldNames.PATIO,
    isRequired: false,
  },
  {
    appliedTo: [classTypes.SHELL],
    displayName: ISHELL_PROPERTY_LABELS.plan,
    enabled: true,
    id: fieldNames.PLAN_FIELD,
    isRequired: false,
  },
  {
    appliedTo: [classTypes.SINGLE, classTypes.SHELL],
    displayName: IPLAN_PROPERTY_LABELS.planCreatedBy,
    enabled: true,
    id: fieldNames.PLAN_CREATED_BY,
    isRequired: false,
  },
  {
    appliedTo: [classTypes.SINGLE, classTypes.SHELL],
    displayName: IPLAN_PROPERTY_LABELS.planCreatedDateTime,
    enabled: true,
    id: fieldNames.PLAN_CREATED_DATE,
    isRequired: false,
  },
  {
    appliedTo: [classTypes.SINGLE, classTypes.SHELL],
    displayName: IPLAN_PROPERTY_LABELS.planModifiedDateTime,
    enabled: true,
    id: fieldNames.PLAN_MODIFIED_DATE,
    isRequired: false,
  },
  {
    appliedTo: [classTypes.SINGLE],
    displayName: IPLAN_PROPERTY_LABELS.planOwnedByLennar,
    enabled: true,
    id: fieldNames.PLAN_OWNED_BY_LENNAR,
    isRequired: false,
  },
  {
    appliedTo: [classTypes.SINGLE],
    displayName: IPLAN_PROPERTY_LABELS.planStatus,
    enabled: true,
    id: fieldNames.PLAN_STATUS,
    isRequired: false,
  },
  {
    appliedTo: [classTypes.SINGLE],
    displayName: IPLAN_PROPERTY_LABELS.planType,
    enabled: true,
    id: fieldNames.PLAN_TYPE,
    isRequired: false,
  },
  {
    appliedTo: [classTypes.SINGLE, classTypes.UNIT, classTypes.SHELL],
    displayName: IPLAN_PROPERTY_LABELS.region,
    enabled: true,
    id: fieldNames.REGION,
    isRequired: true,
  },
  {
    appliedTo: [classTypes.SHELL],
    displayName: ISHELL_PROPERTY_LABELS.shellStatus,
    enabled: true,
    id: shellFieldNames.SHELL_STATUS,
    isRequired: false,
  },
  {
    appliedTo: [classTypes.SHELL],
    displayName: ISHELL_PROPERTY_LABELS.shellType,
    enabled: true,
    id: shellFieldNames.SHELL_TYPE,
    isRequired: false,
  },
  {
    appliedTo: [classTypes.SINGLE],
    displayName: IPLAN_PROPERTY_LABELS.sqftOfHomeConditionedSpace,
    enabled: true,
    id: fieldNames.SQFT_OF_HOME_CONDITIONED_SPACE,
    isRequired: false,
  },
  {
    appliedTo: [classTypes.UNIT],
    displayName: IUNIT_PROPERTY_LABELS.sqftOfUnitConditionedSpace,
    enabled: true,
    id: unitFieldNames.SQFT_OF_UNIT_CONDITIONED_SPACE,
    isRequired: false,
  },
  {
    appliedTo: [classTypes.SINGLE, classTypes.UNIT, classTypes.SHELL],
    displayName: IPLAN_PROPERTY_LABELS.stories,
    enabled: true,
    id: fieldNames.STORIES,
    isRequired: false,
  },
  {
    appliedTo: [classTypes.UNIT, classTypes.SHELL],
    displayName: IUNIT_PROPERTY_LABELS.structureType,
    enabled: true,
    id: fieldNames.STRUCTURE_TYPE,
    isRequired: false,
  },
  {
    appliedTo: [classTypes.SINGLE, classTypes.UNIT],
    displayName: IPLAN_PROPERTY_LABELS.study,
    enabled: true,
    id: fieldNames.STUDY,
    isRequired: false,
  },
  {
    appliedTo: [classTypes.SINGLE, classTypes.UNIT],
    displayName: IPLAN_PROPERTY_LABELS.sunRoom,
    enabled: true,
    id: fieldNames.SUN_ROOM,
    isRequired: false,
  },
  {
    appliedTo: [classTypes.SHELL],
    displayName: ISHELL_PROPERTY_LABELS.underRoofSqFt,
    enabled: true,
    id: shellFieldNames.BUILDING_UNDER_ROOF_SQ_FT,
    isRequired: false,
  },
  {
    appliedTo: [classTypes.UNIT],
    displayName: IUNIT_PROPERTY_LABELS.unitDepthFeet,
    enabled: true,
    id: unitFieldNames.DEPTH_UNIT_FT,
    isRequired: false,
  },
  {
    appliedTo: [classTypes.UNIT],
    displayName: IUNIT_PROPERTY_LABELS.unitDepthInch,
    enabled: true,
    id: unitFieldNames.DEPTH_UNIT_IN,
    isRequired: false,
  },
  {
    appliedTo: [classTypes.SHELL],
    displayName: ISHELL_PROPERTY_LABELS.units,
    enabled: true,
    id: shellFieldNames.UNITS,
    isRequired: false,
  },
  {
    appliedTo: [classTypes.UNIT],
    displayName: IUNIT_PROPERTY_LABELS.unitSqft,
    enabled: true,
    id: unitFieldNames.SQFT_UNIT,
    isRequired: false,
  },
  {
    appliedTo: [classTypes.UNIT],
    displayName: IUNIT_PROPERTY_LABELS.unitType,
    enabled: true,
    id: unitFieldNames.UNIT_TYPE,
    isRequired: false,
  },
  {
    appliedTo: [classTypes.UNIT],
    displayName: IUNIT_PROPERTY_LABELS.unitWidthFeet,
    enabled: true,
    id: unitFieldNames.WIDTH_UNIT_FT,
    isRequired: false,
  },
  {
    appliedTo: [classTypes.UNIT],
    displayName: IUNIT_PROPERTY_LABELS.unitWidthInch,
    enabled: true,
    id: unitFieldNames.WIDTH_UNIT_IN,
    isRequired: false,
  },
  {
    appliedTo: [classTypes.SINGLE, classTypes.UNIT],
    displayName: IPLAN_PROPERTY_LABELS.valueEngineered,
    enabled: true,
    id: fieldNames.VALUE_ENGINEERED,
    isRequired: false,
  },
  {
    appliedTo: [classTypes.SINGLE],
    displayName: IPLAN_PROPERTY_LABELS.widthOfThePlanInFeet,
    enabled: true,
    id: fieldNames.WIDTH_FT,
    isRequired: false,
  },
  {
    appliedTo: [classTypes.SINGLE],
    displayName: IPLAN_PROPERTY_LABELS.widthOfThePlanInInch,
    enabled: true,
    id: fieldNames.WIDTH_IN,
    isRequired: false,
  },
  {
    appliedTo: [classTypes.SINGLE, classTypes.UNIT, classTypes.SHELL],
    displayName: IPLAN_PROPERTY_LABELS.yearOfCreation,
    enabled: true,
    id: fieldNames.YEAR_OF_CREATION,
    isRequired: false,
  },
  {
    appliedTo: [classTypes.SINGLE, classTypes.UNIT, classTypes.SHELL],
    displayName: IPLAN_PROPERTY_LABELS.exportFloorPlans,
    enabled: true,
    id: fieldNames.EXPORT_FLOOR_PLANS,
    isRequired: false,
  },
]
